var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C63185C7-0FA7-4D69-B17E-BC4D425270A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-1257.000000, -276.000000)",
    fill: "#FF5000",
    stroke: "#FF5000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-address",
    transform: "translate(1010.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(247.189655, 157.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59482759,15 L3.56034483,15 C2.71908621,15 2.03448276,14.327 2.03448276,13.5 L2.03448276,12 C2.03448276,11.509 2.21758621,11.04 2.54310345,10.683 L2.54310345,4.317 C2.21758621,3.959 2.03448276,3.491 2.03448276,3 L2.03448276,1.5 C2.03448276,0.673 2.71908621,0 3.56034483,0 L5.59482759,0 C6.43608621,0 7.12068966,0.673 7.12068966,1.5 L7.12068966,3 C7.12068966,3.491 6.93758621,3.959 6.61206897,4.317 L6.61206897,10.682 C6.93758621,11.04 7.12068966,11.509 7.12068966,12 L7.12068966,13.5 C7.12068966,14.327 6.43608621,15 5.59482759,15 Z M3.56034483,1 C3.27958621,1 3.05172414,1.224 3.05172414,1.5 L3.05172414,3 C3.05172414,3.284 3.1737931,3.551 3.38639655,3.733 C3.49727586,3.828 3.56034483,3.965 3.56034483,4.11 L3.56034483,10.89 C3.56034483,11.035 3.49727586,11.172 3.38639655,11.267 C3.1737931,11.448 3.05172414,11.716 3.05172414,12 L3.05172414,13.5 C3.05172414,13.775 3.27958621,14 3.56034483,14 L5.59482759,14 C5.87558621,14 6.10344828,13.775 6.10344828,13.5 L6.10344828,12 C6.10344828,11.716 5.98137931,11.448 5.76877586,11.267 C5.65789655,11.172 5.59482759,11.034 5.59482759,10.89 L5.59482759,4.11 C5.59482759,3.965 5.65789655,3.828 5.76877586,3.733 C5.98137931,3.551 6.10344828,3.284 6.10344828,3 L6.10344828,1.5 C6.10344828,1.224 5.87558621,1 5.59482759,1 L3.56034483,1 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54310345,14 L1.01724138,14 C0.446568966,14 0,13.561 0,13 L0,2 C0,1.449 0.456741379,1 1.01724138,1 L2.54310345,1 C2.82386207,1 3.05172414,1.224 3.05172414,1.5 C3.05172414,1.776 2.82386207,2 2.54310345,2 L1.01724138,2 L1.01724138,13 L2.54310345,13 C2.82386207,13 3.05172414,13.224 3.05172414,13.5 C3.05172414,13.776 2.82386207,14 2.54310345,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2586207,14 L6.61206897,14 C6.33131034,14 6.10344828,13.776 6.10344828,13.5 C6.10344828,13.224 6.33131034,13 6.61206897,13 L15.2586207,13 L15.2586207,2 L6.61206897,2 C6.33131034,2 6.10344828,1.776 6.10344828,1.5 C6.10344828,1.224 6.33131034,1 6.61206897,1 L15.2586207,1 C15.8292931,1 16.2758621,1.439 16.2758621,2 L16.2758621,13 C16.2758621,13.561 15.8292931,14 15.2586207,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7327586,6 L8.64655172,6 C8.3657931,6 8.13793103,5.776 8.13793103,5.5 L8.13793103,3.5 C8.13793103,3.224 8.3657931,3 8.64655172,3 L13.7327586,3 C14.0135172,3 14.2413793,3.224 14.2413793,3.5 L14.2413793,5.5 C14.2413793,5.776 14.0135172,6 13.7327586,6 Z M9.15517241,5 L13.2241379,5 L13.2241379,4 L9.15517241,4 L9.15517241,5 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.6810345,
    y: 9,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.6810345,
    y: 7,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.6810345,
    y: 11,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.13793103,
    y: 9,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.13793103,
    y: 7,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.13793103,
    y: 11,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.2241379,
    y: 9,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.2241379,
    y: 7,
    width: 1.01724138,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13.2241379,
    y: 11,
    width: 1.01724138,
    height: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone);
export default __webpack_public_path__ + "static/media/ico_phone.991a9a8acf976e0c782f191c8feb404d.svg";
export { ForwardRef as ReactComponent };